/**
 * Nomenclatura mostrata all'utente (Andrea 2026-09-29).
 *
 * La modalità "Mantra" si chiama "Pro", i ruoli hanno sigle nostre e il
 * D-Factor diventa "Bonus Difensivo". SOLO testo a video: nel database, nelle
 * API, nei filtri (?ruolo_mantra=) e nelle combinazioni dei moduli restano i
 * codici originali (Por/B/Dc/Dd/Ds/M/C/E/T/W/A/Pc), quindi il confronto fra
 * ruoli si fa sempre sul codice, e si traduce solo quando si stampa.
 *
 * Per tornare ai nomi vecchi basta mettere NOMENCLATURA_PRO = false.
 * Il backend (Excel/PDF) ha lo stesso interruttore in
 * `backend/app/core/nomenclatura.py`.
 */

import { linguaCorrente } from "../../i18n";

export const NOMENCLATURA_PRO = true;

/** Nome della modalità a ruoli multipli ("Pro", ex "Mantra"). */
export const NOME_MODALITA_PRO = NOMENCLATURA_PRO ? "Pro" : "Mantra";

/** Nome del modificatore difesa ("Bonus Difensivo", ex "D-Factor"). */
export const NOME_BONUS_DIFENSIVO = NOMENCLATURA_PRO ? "Bonus Difensivo" : "D-Factor";

/** Codice ruolo (come in DB) → sigla mostrata, per lingua (Andrea
 * 2026-10-10: le sigle inglesi solo con l'app in inglese). */
const SIGLE_IT: Record<string, string> = {
  por: "Por",
  b: "BD",
  dc: "DC",
  dd: "TD",
  ds: "TS",
  m: "CD",
  c: "CC",
  e: "EC",
  t: "TQ",
  w: "AL",
  a: "SP",
  pc: "PC",
};
const SIGLE_EN: Record<string, string> = {
  por: "GK",
  b: "BB",
  dc: "CB",
  dd: "RB",
  ds: "LB",
  m: "MD",
  c: "MC",
  e: "WM",
  t: "AM",
  w: "AW",
  a: "FW",
  pc: "ST",
};

// Il cambio lingua ricarica la pagina: basta leggerla a ogni chiamata.
function sigle(): Record<string, string> {
  return linguaCorrente() === "en" ? SIGLE_EN : SIGLE_IT;
}

/** Sigla di un ruolo della modalità Pro. Accetta anche i composti "M/C" e
 * i codici in qualunque maiuscolo ("DC", "dc"). Un codice sconosciuto torna
 * com'e'. NON usarla sulle lettere Classic (P/D/C/A): "C" e "A" esistono
 * anche lì e verrebbero tradotte. */
export function siglaRuolo(codice: string | null | undefined): string {
  if (!codice) return "";
  if (!NOMENCLATURA_PRO) return codice;
  return codice
    .split("/")
    .map((c) => sigle()[c.trim().toLowerCase()] ?? c)
    .join("/");
}

/** Più ruoli Pro uniti ("Dc", "B" → "DC/BD"). */
export function sigleRuoli(codici: ReadonlyArray<string> | null | undefined, sep = "/"): string {
  return (codici ?? []).map(siglaRuolo).join(sep);
}

/** Etichetta di uno slot del campo: tradotta solo in modalità Pro (in
 * Classic gli slot sono P/D/C/A e restano tali). */
export function siglaSlot(label: string | null | undefined, modalitaPro: boolean): string {
  if (!label) return "";
  return modalitaPro ? siglaRuolo(label) : label;
}

/** Le etichette di un campo sono della modalità Pro? In Pro il portiere è
 * "Por", in Classic "P": basta guardare se c'e' un "Por" fra gli slot. Serve
 * ai componenti (campo, scelta slot) che non ricevono la modalità. */
export function etichetteSonoPro(labels: ReadonlyArray<string | null | undefined>): boolean {
  return labels.some((l) => !!l && l.split("/").some((c) => c.trim().toLowerCase() === "por"));
}
